import React from "react";
import { Calendar as CalendarIcon, Apple, X } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

// Lista de proveedores disponibles — agregar Outlook/Microsoft 365 más
// adelante es solo sumar una entrada acá, sin rediseñar la card ni el sheet.
const PROVIDERS = [
  { id: "google", icon: CalendarIcon, iconBg: "bg-[#028CF8]/10 text-[#028CF8]", titleKey: "calendarSheet.googleTitle", subtitleKey: "calendarSheet.googleSubtitle" },
  { id: "apple", icon: Apple, iconBg: "bg-slate-900/5 text-slate-800", titleKey: "calendarSheet.appleTitle", subtitleKey: "calendarSheet.appleSubtitle" },
];

export function CalendarPickerSheet({ open, onClose, onSelect }) {
  const { t } = useLanguage();
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-[70] flex items-end sm:items-center justify-center" onClick={onClose} data-testid="calendar-picker-sheet">
      <div
        className="bg-white w-full sm:max-w-sm rounded-t-2xl sm:rounded-2xl overflow-hidden"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-slate-100">
          <h3 className="font-poppins font-bold text-base text-slate-900" data-testid="calendar-sheet-title">{t("calendarSheet.title")}</h3>
          <button onClick={onClose} data-testid="calendar-sheet-close" className="p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="py-2">
          {PROVIDERS.map(({ id, icon: Icon, iconBg, titleKey, subtitleKey }) => (
            <button
              key={id}
              type="button"
              onClick={() => onSelect(id)}
              data-testid={`calendar-option-${id}`}
              className="w-full flex items-center gap-3.5 px-5 py-3.5 min-h-[64px] hover:bg-slate-50 active:bg-slate-100 transition-colors text-left"
            >
              <div className={`h-11 w-11 rounded-xl flex items-center justify-center flex-shrink-0 ${iconBg}`}>
                <Icon className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-poppins font-semibold text-sm text-slate-900">{t(titleKey)}</p>
                <p className="text-xs text-slate-500 mt-0.5 truncate">{t(subtitleKey)}</p>
              </div>
            </button>
          ))}
        </div>
        <div className="border-t border-slate-100 p-3">
          <button
            onClick={onClose}
            data-testid="calendar-sheet-cancel"
            className="w-full h-12 rounded-xl border border-slate-200 text-slate-600 font-poppins font-semibold text-sm hover:bg-slate-50 transition-colors"
          >
            {t("calendarSheet.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
